'use client';

import { c as _c } from "react/compiler-runtime";
import { Spinner } from '@common/components';
import { useSuspenseQuery } from '@tanstack/react-query';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { UnauthQueryOptions } from '@/api';
import { isSecondDecemberEvent } from '@/app/donation/event/market/invite/_utils/isSecondDecemberEvent';
import { INVITE_CONFIG } from '../../constants';
interface RecentWinnerData {
  maskedNickname: string;
  rewardPoint: number;
}
export const RecentWinnersSection = () => {
  const $ = _c(22);
  const [currentCarouselIndex, setCurrentCarouselIndex] = useState(0);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/home-donation-event-history/reward/recent"]({
        query: {
          eventCodeList: isSecondDecemberEvent() ? ["INVITEE_ON_JOIN_2025_12_2ND", "INVITER_ON_DONATION_2025_12_2ND"] : ["INVITEE_ON_JOIN_2025_12_1ND", "INVITER_ON_DONATION_2025_12_1ND"],
          size: 3
        }
      }),
      select: _temp
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: recentWinnersData,
    isLoading
  } = useSuspenseQuery(t0);
  const hasWinnersData = (recentWinnersData?.length ?? 0) > 0;
  let t1;
  let t2;
  if ($[1] !== hasWinnersData || $[2] !== recentWinnersData.length) {
    t1 = () => {
      if (!hasWinnersData) {
        return;
      }
      const carouselInterval = setInterval(() => {
        setCurrentCarouselIndex(prevIndex => (prevIndex + 1) % recentWinnersData.length);
      }, INVITE_CONFIG.animation.carouselRotationIntervalMs);
      return () => clearInterval(carouselInterval);
    };
    t2 = [recentWinnersData.length, hasWinnersData];
    $[1] = hasWinnersData;
    $[2] = recentWinnersData.length;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (isLoading) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="w-full rounded-xsmall bg-Gray-25 py-100 flex-center"><Spinner size={16} /></div>;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  if (!hasWinnersData) {
    return null;
  }
  const currentWinnerMessage = recentWinnersData[currentCarouselIndex];
  const nextWinnerMessage = recentWinnersData[(currentCarouselIndex + 1) % recentWinnersData.length];
  const secondNextWinnerMessage = recentWinnersData[(currentCarouselIndex + 2) % recentWinnersData.length];
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <QuoteIcon />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      WebkitMask: "linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)",
      mask: "linear-gradient(to bottom, transparent 0%, black 10%, black 90%, transparent 100%)"
    };
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `carousel-container-${currentCarouselIndex}`;
  let t6;
  let t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      y: 0
    };
    t7 = {
      y: -64
    };
    t8 = {
      duration: INVITE_CONFIG.animation.transitionDurationSeconds,
      ease: INVITE_CONFIG.animation.easingCurve
    };
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t6 = $[8];
    t7 = $[9];
    t8 = $[10];
  }
  let t9;
  if ($[11] !== currentWinnerMessage) {
    t9 = <WinnerMessage winner={currentWinnerMessage} opacity={1} animateOpacity={0.2} />;
    $[11] = currentWinnerMessage;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== nextWinnerMessage) {
    t10 = <WinnerMessage winner={nextWinnerMessage} opacity={0.2} animateOpacity={1} />;
    $[13] = nextWinnerMessage;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== secondNextWinnerMessage) {
    t11 = <WinnerMessage winner={secondNextWinnerMessage} opacity={0.2} animateOpacity={0.2} />;
    $[15] = secondNextWinnerMessage;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t10 || $[18] !== t11 || $[19] !== t5 || $[20] !== t9) {
    t12 = <div className="flex w-full flex-col items-center">{t3}<div className="relative h-146 w-full overflow-hidden" style={t4}><motion.div key={t5} initial={t6} animate={t7} transition={t8} className="flex flex-col gap-12">{t9}{t10}{t11}</motion.div></div></div>;
    $[17] = t10;
    $[18] = t11;
    $[19] = t5;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  return t12;
};
const QuoteIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="size-20 flex-center"><svg width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M8.33 25C8.33 20.4 11.731 16.67 16 16.67V13.33C9.81 13.33 5 18.15 5 24.33V31.67H16.67V20H8.33V25ZM25 25C25 20.4 28.4 16.67 32.67 16.67V13.33C26.48 13.33 21.67 18.15 21.67 24.33V31.67H33.33V20H25V25Z" fill="#ffe560" /></svg></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
interface WinnerMessageProps {
  winner: RecentWinnerData;
  opacity: number;
  animateOpacity: number;
}
const WinnerMessage = t0 => {
  const $ = _c(11);
  const {
    winner,
    opacity,
    animateOpacity
  } = t0;
  const t1 = winner.maskedNickname;
  let t2;
  if ($[0] !== winner.rewardPoint) {
    t2 = winner.rewardPoint.toLocaleString();
    $[0] = winner.rewardPoint;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const winnerMessageText = `${t1}님이\n${t2}원을 받았어요!`;
  let t3;
  if ($[2] !== opacity) {
    t3 = {
      opacity
    };
    $[2] = opacity;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== animateOpacity) {
    t4 = {
      opacity: animateOpacity
    };
    $[4] = animateOpacity;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      duration: INVITE_CONFIG.animation.transitionDurationSeconds,
      ease: "easeOut"
    };
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t3 || $[8] !== t4 || $[9] !== winnerMessageText) {
    t6 = <motion.div initial={t3} animate={t4} transition={t5} className="whitespace-pre-line text-center font-700 text-Y-300 typo-body1">{winnerMessageText}</motion.div>;
    $[7] = t3;
    $[8] = t4;
    $[9] = winnerMessageText;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context?.contents ?? [] as RecentWinnerData[];
}